import { useContext } from "react";
import { Table } from '../../../components/table/Table';
import Loader from "../../../components/loader/Loader";
import { FeatureContext } from "../../../Context";
import { lang } from "../../../Utils";
import { Spinner, useBoolean } from "@chakra-ui/react";
import { BsDownload } from "react-icons/bs";
import { ButtonIcon } from "../../../components/button/Button";
import { downloadFile } from "../../../Utils";
import { getInvoiceAttachment } from "../Services";

const Invoices = () => {

  const context = useContext(FeatureContext);

  return <div>
    <Table dataSet={context?.invoices} pagination={true} hover={false}>
      <Table.Caption>{lang('Invoices List')}</Table.Caption>
      <Table.Header>
        <Table.Header.Column sortKey={"salesOrderItem"} sortable={true}>{lang('N. Line')}</Table.Header.Column>
        <Table.Header.Column sortKey={"billingDocument"} sortable={true}>{lang('Billing Document Number')}</Table.Header.Column>
        <Table.Header.Column sortKey={"actualInvoicedQuantity"} sortable={true}>{lang('Quantity')}</Table.Header.Column>
        <Table.Header.Column sortKey={"billingDate"} sortable={true}>{lang('Billing Date')}</Table.Header.Column>
        <Table.Header.Column sortKey={"netValue"} sortable={true}>{lang('Billed Price')}</Table.Header.Column>
      </Table.Header>
      <Table.Body dataSet={context?.invoices} noDataMessage={lang('No Data available to display')}>
        <Table.Body.Text label={lang('N. Line')} field="salesOrderItem" />
        <Table.Body.Text label={lang('Billing Document Number')} field="billingDocument" />
        <Table.Body.Text label={lang('Quantity')} field="actualInvoicedQuantity" />
        <Table.Body.Date label={lang('Billing Date')} field="billingDate" />
        <Table.Body.Currency label={lang('Invoice')} currency="currency" field="netValue" />
      </Table.Body>
    </Table>
  </div>

}

export default Invoices;